import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';
import { FaBars, FaTimes } from 'react-icons/fa';

const Navbar = () => {
  const [click, setClick] = useState(false);
  const [petals, setPetals] = useState([]);

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  const createPetal = (e) => {
    const colors = ['#ffb6c1', '#ff69b4', '#db7093', '#ff1493', '#c71585'];
    const petal = {
      id: Date.now(),
      x: e.clientX,
      y: e.clientY - 80, // Adjust for navbar height
      color: colors[Math.floor(Math.random() * colors.length)],
      size: Math.random() * 10 + 5,
      speed: Math.random() * 2 + 1,
      angle: Math.random() * 360,
      rotation: Math.random() * 10 - 5
    };
    setPetals(prev => [...prev, petal]);
  };

  useEffect(() => {
    const timer = setInterval(() => {
      setPetals(prev => 
        prev.map(petal => ({
          ...petal,
          y: petal.y + petal.speed,
          angle: petal.angle + petal.rotation
        })).filter(petal => petal.y < window.innerHeight)
      );
    }, 50);

    return () => clearInterval(timer);
  }, []);

  return (
    <>
      <nav className="navbar">
        <div className="navbar-container">
        <Link to="/" className="navbar-logo" onClick={closeMobileMenu}>
          <img src="/images/icon.png" alt="Infuse Logo" className="logo-icon" />
          <img src="/images/textlogo.png" alt="Infuse Logo" className="logo-image" />
        </Link>
          <div className="menu-icon" onClick={handleClick}>
            {click ? <FaTimes /> : <FaBars />}
          </div>
          <ul className={click ? 'nav-menu active' : 'nav-menu'}>
            <li className="nav-item">
              <Link 
                to="/" 
                className="nav-link" 
                onClick={closeMobileMenu}
                onMouseEnter={createPetal}
              >
                Home
              </Link>
            </li>
            <li className="nav-item">
              <Link 
                to="/products" 
                className="nav-link" 
                onClick={closeMobileMenu}
                onMouseEnter={createPetal}
              >
                Products
              </Link>
            </li>
            <li className="nav-item">
              <Link 
                to="/about" 
                className="nav-link" 
                onClick={closeMobileMenu}
                onMouseEnter={createPetal}
              >
                About
              </Link>
            </li>
            <li className="nav-item">
              <Link 
                to="/contact" 
                className="nav-link" 
                onClick={closeMobileMenu}
                onMouseEnter={createPetal}
              >
                Contact
              </Link>
            </li>
          </ul>
        </div>
      </nav>
      
      {/* Petals container */}
      <div className="petals-container">
        {petals.map(petal => (
          <div 
            key={petal.id}
            className="petal"
            style={{
              left: `${petal.x}px`,
              top: `${petal.y}px`,
              backgroundColor: petal.color,
              width: `${petal.size}px`,
              height: `${petal.size}px`,
              transform: `rotate(${petal.angle}deg)`,
              position: 'absolute',
              borderRadius: '50% 0 50% 50%',
              opacity: 0.7
            }}
          />
        ))}
      </div>
    </>
  );
};

export default Navbar;